import { Icon } from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils';
import { Button, Stack, Typography } from '@mui/material';
import { memo } from 'react';
import { useBrowseNotificationsCountApi } from '../../api/use-browse-notifications-count-api';
import { useUpdateNotificationStatusesMutationApi } from '../../api/use-update-notification-statuses-mutation-api';
import { useNotificationStore } from '../../store';
import {
  NotificationMessageChannel,
  NotificationMessageGroup,
  NotificationStatus,
} from '../../types';
import * as Styled from './styles';
import * as SX from './sx';
import type { NotificationHeaderNavigationProps as Props } from './types';

export const NotificationHeaderNavigation = memo(
  ({ className, onClose }: Props) => {
    const api = useUpdateNotificationStatusesMutationApi();
    const count = useBrowseNotificationsCountApi(NotificationStatus.ALL);
    const markAllNotificationsAsSeen =
      useNotificationStore.useMarkAllNotificationsAsSeen();
    const closeDrawer = useNotificationStore.useCloseDrawer();

    const disabled = count.data?.every(
      (item) => item.status !== NotificationStatus.SENT
    );

    const handleMarkAll = () => {
      if (!disabled) {
        api
          .mutateAsync({
            groups: [
              NotificationMessageGroup.EVENT,
              NotificationMessageGroup.UPDATE,
            ],
            channels: [NotificationMessageChannel.NOTIFICATION],
          })
          .then(() => {
            markAllNotificationsAsSeen();
          });
      }
    };

    return (
      <Styled.Wrapper
        className={classnames('NotificationHeaderNavigation', className)}
        sx={SX.root}
      >
        <Typography sx={SX.headerTitle}>Notifications</Typography>

        <Stack direction="row" alignItems="center" gap={0.5}>
          <Button
            variant="text"
            size="xsmall"
            color="default"
            sx={SX.button}
            startIcon={<Icon name="done-all-outline" />}
            disabled={disabled}
            onClick={handleMarkAll}
          >
            Mark all as read
          </Button>

          <Icon
            name="close"
            size={20}
            color="grey.500"
            sxx={SX.closeIcon}
            onClick={closeDrawer}
          />
        </Stack>
      </Styled.Wrapper>
    );
  }
);

NotificationHeaderNavigation.displayName = 'NotificationHeaderNavigation';
